module.exports = __webpack_public_path__ + "img/logo.e9ca331.png";